// F1 Races Page
import React from 'react';
import { useF1Championship } from '../../hooks/useF1Championship';
import F1PageTemplate from '../../components/f1/F1PageTemplate';
import { racesConfig } from '../../components/f1/RacesComponent';
import RacesComponent from '../../components/f1/RacesComponent';

const F1RacesPage = () => {
  const { data } = useF1Championship();

  const stats = racesConfig.stats.map(stat => ({
    ...stat,
    value: typeof stat.value === 'function' ? stat.value(data) : stat.value
  }));

  return (
    <F1PageTemplate
      title={racesConfig.title}
      subtitle={racesConfig.subtitle}
      summary={racesConfig.summary}
      stats={stats}
    >
      <RacesComponent data={data} />
    </F1PageTemplate>
  );
};

export default F1RacesPage;
